<template>
  <div class="relatedList">
    <viewHeader></viewHeader>
    <div class="content">
      <el-card class="box-card" shadow="never">
        <div slot="header" class="clearfix">
          <img src="../assets/img/icon0.png" alt="" class="L" />
          <span class="L">{{ searchQuery.registration }} 的相关文献</span>
        </div>
        <div class="tags">
        </div>
        <div
          class="resultList"
          v-loading.fullscreen="loading"
          element-loading-text="拼命加载中"
          v-show="hasData"
        >
          <ul>
            <li
              v-for="(item, index) in searchData"
              :key="index"
              v-loading="item.loading"
            >
              <el-row :gutter="20" class="listTitle">
                <el-col :span="14" class="title">
                  {{ item.title_en }}
                  <img v-show="item.is_download" class="pptIcon" src="../assets/img/ppt.png" alt="">
                </el-col>
                <el-col
                  :span="5"
                  class="YXYZ clearfix"
                  v-if="item.impact_factor && item.impact_factor !== ''"
                >
                  <img src="../assets/img/icon6.png" alt="" class="L" />
                  <span class="L">影响因子：{{ item.impact_factor }}</span>
                </el-col>
                <el-col
                  :span="5"
                  class="RGBZ clearfix"
                  v-if="item.has_manual_curation !== 0"
                >
                  <img src="../assets/img/icon5.png" alt="" class="L" />
                  <span class="L"
                    >人工标注：{{ item.has_manual_curation }}</span
                  >
                </el-col>
              </el-row>
              <div class="tags">
                <articleTags :pubdate="item.pubdate_show" :language="item.language" :pubType="item.pub_type"></articleTags>
              </div>
              <el-row class="listInfo">
                <el-col :span="10"><span>PMID：</span>{{ item.pmid }}</el-col>
                <el-col :span="10" v-if="item.doi"><span>DOI：</span>{{ item.doi }}</el-col>
                <el-col :span="20"
                  ><span>期刊：</span>{{ item.journal_name }}</el-col
                >
                <!-- <el-col :span="20"
                  ><span>发表时间：</span>{{ item.pubdate_show }}</el-col
                > -->
                <el-col
                  :span="20"
                  v-if="
                    item.keyword_categories != null &&
                    item.keyword_categories['Diseases']
                  "
                >
                  <span>疾病：</span>
                  <em
                    v-for="(disease, disIndex) in item.keyword_categories[
                      'Diseases'
                    ]"
                    :key="disIndex"
                    >{{ disease[0] + "(" + disease[1] + ")"
                    }}<i
                      v-if="
                        disIndex + 1 <
                        item.keyword_categories['Diseases'].length
                      "
                    >
                      、</i
                    ></em
                  >
                </el-col>
                <el-col
                  :span="20"
                  v-if="
                    item.keyword_categories != null &&
                    item.keyword_categories['Drugs and Chemicals']
                  "
                >
                  <span>药品：</span>
                  <em
                    v-for="(drug, drugIndex) in item.keyword_categories[
                      'Drugs and Chemicals'
                    ]"
                    :key="drugIndex"
                    >{{ drug[0] + "(" + drug[1] + ")"
                    }}<i
                      v-if="
                        drugIndex + 1 <
                        item.keyword_categories['Drugs and Chemicals'].length
                      "
                    >
                      、</i
                    ></em
                  >
                </el-col>
                <el-col
                  :span="20"
                  v-if="
                    item.keyword_categories != null &&
                    item.keyword_categories['Geographic Locations']
                  "
                >
                  <span>地理位置：</span>
                  <em
                    v-for="(location, locationIndex) in item.keyword_categories[
                      'Geographic Locations'
                    ]"
                    :key="locationIndex"
                    >{{ location[0] + "(" + location[1] + ")"
                    }}<i
                      v-if="
                        locationIndex + 1 <
                        item.keyword_categories['Geographic Locations'].length
                      "
                    >
                      、</i
                    ></em
                  >
                </el-col>
                <!-- 隐藏研究背景，研究目的，研究结论 添加important_message字段 2021-01-05 qinrui-->
                <!-- <el-col :span="20" v-if="item.key_information"> -->
                <el-col :span="20" v-if="item.important_message && item.important_message.length != 0">
                  <span>重点信息：</span>
                  <div :class="item.key_height">
                    <p class="key_infor" v-for="(important, importantIndex) in item.important_message" :key="'重点信息' + importantIndex">
                      {{ `● ${important}` }}
                    </p>
                    <!-- <p
                      class="key_infor"
                      v-if="
                        item.key_information[0] &&
                        item.key_information[0][1] !== ''
                      "
                    >
                      <span>研究背景：</span>{{ item.key_information[0][1] }}
                    </p>
                    <p
                      class="key_infor"
                      v-if="
                        item.key_information[1] &&
                        item.key_information[1][1] !== ''
                      "
                    >
                      <span>研究目的：</span>{{ item.key_information[1][1] }}
                    </p>
                    <p
                      class="key_infor"
                      v-if="
                        item.key_information[4] &&
                        item.key_information[4][1] !== ''
                      "
                    >
                      <span>研究结论：</span>{{ item.key_information[4][1] }}
                    </p> -->
                  </div>
                  <em
                    class="R down"
                    :class="
                      item.key_height === 'initHeight'
                        ? 'el-icon-arrow-down'
                        : 'el-icon-arrow-up'
                    "
                    @click="showFull(item.key_height, index)"
                  ></em>
                  <!-- <button class="R down" @click="showFull(item.key_height, index)">{{ item.key_height === 'initHeight' ? '展开' : '收起'}}</button> -->
                </el-col>
              </el-row>
              <div class="action">
                <a
                  href="javascript:;"
                  class="translate"
                  @click="translateFullText(item.pmid, index, item.translate)"
                  title="翻译"
                >
                  <!-- <img src="../assets/img/icon1.png" alt="" class="translate"> -->
                </a>
                <a
                  href="javascript:;"
                  class="fullText"
                  title="查看全文"
                  @click="showFullText(item.pmid)"
                >
                  <!-- <img src="../assets/img/icon2.png" alt="" class="fullText"> -->
                </a>
                <a
                  href="javascript:;"
                  :class="item.is_collected ? 'collectionTrue' : 'collection'"
                  title="收藏"
                  @click="collection(item.pmid, item.is_collected, index)"
                >
                  <!-- <img src="../assets/img/icon3.png" alt="" class="collection"> -->
                </a>
                <!-- <a href="javascript:;" class="share" title="分享"> -->
                <!-- <img src="../assets/img/icon4.png" alt="" class="share"> -->
                <!-- </a> -->
              </div>
            </li>
          </ul>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { md5 } from "md5js";
import viewHeader from "./viewHeader";
import articleTags from '../components/articleTags.vue'
import {
  trilaRelatedArticle,
  translateInfo,
  collection,
} from "../service/getData";
import { webTrackerEvent } from "../utils/tracker";
export default {
  name: "related",
  components: {
    viewHeader,
    articleTags
  },
  data() {
    return {
      hasData: true, // 是否有数据
      secret: "4ede4aafbzd51cbz3e32bzb781bzee9813d17154",
      clientId: "zeta",
      loading: true, // 页面加载动画
      searchQuery: {},
      searchData: [], // 搜索出的文献数据
      titleJson: {},
      importantJson: {}, // 重点信息
      token: window.localStorage.getItem("PUBMEDSEARCHTOKEN"),
      openid: window.localStorage.getItem("PUBMEDSEARCHOPENID"),
    };
  },
  methods: {
    // 获取研究相关文献
    async handleSearch() {
      this.loading = true;
      const pmids = this.searchQuery.t.split('.');
      const params = {
        pmids
      }
      const res = await trilaRelatedArticle(params);
      if (res && res.data.status === 0) {
        this.loading = false;
        res.data.data.forEach((item, index) => {
          if (item.pubdate_show) {
            item.loading = false;
          }
          item.key_height = "initHeight";
          item.translate = false;
          this.titleJson[index] = item.title_en;
          this.importantJson[index] = item.important_message;
        });
        this.searchData = res.data.data;
      }

      let Logger = webTrackerEvent();
      Logger.push("action", "trial_related_search");
      Logger.push("page_url", window.location.href);
      Logger.push("pmids", pmids);
      Logger.push("token", this.token);
      Logger.push("openid", this.openid);
      Logger.logger();
    },
    // 翻译重点信息
    async translateFullText(pmid, index, translate) {
      this.searchData[index].loading = true;
      let key_type = "";
      if (translate) {
        this.searchData[index].title_en = this.titleJson[index];
        this.searchData[index].important_message = this.importantJson[index];
        key_type = "en_key";
      } else {
        key_type = "cn_key";
      }
      let ts = new Date().getTime();
      let tokenStr = `${this.clientId}.bz${ts}.bz${pmid}.bz${this.secret}`;
      let token = md5(tokenStr, 32);
      const params = {
        client_id: this.clientId,
        ts: Number(ts),
        pmid: String(pmid),
        types: key_type,
        token: token,
      };
      const res = await translateInfo(params);

      let Logger = webTrackerEvent();
      Logger.push("page_url", window.location.href);
      Logger.push("action", "translate");
      Logger.push("language", key_type);
      Logger.push("pmid", pmid);
      Logger.push("token", this.token);
      Logger.push("openid", this.openid);
      Logger.logger();

      if (res.data.status == 0) {
        if (!translate) {
          this.searchData[index].title_en = res.data.data.title;
          this.searchData[index].key_information = res.data.data.sentence;
          this.searchData[index].important_message = res.data.data.important_message;
          this.searchData[index].translate = true;
          this.searchData[index].loading = false;
          return;
        }
        this.searchData[index].key_information = res.data.data.sentence;
        this.searchData[index].translate = false;
        this.searchData[index].loading = false;
      }
    },
    // 展开全文
    showFull(key_height, index) {
      if (key_height === "initHeight") {
        this.searchData[index]["key_height"] = "autoHeight";
      } else {
        this.searchData[index]["key_height"] = "initHeight";
      }
    },
    // 收藏还是取消收藏
    collection(pmid, collect, index) {
      if (!collect) {
        let Logger = webTrackerEvent();
        Logger.push("page_url", window.location.href);
        Logger.push("action", "collection");
        Logger.push("pmid", pmid);
        Logger.push("token", this.token);
        Logger.push("openid", this.openid);
        Logger.logger();
        collection("POST", { pmid: pmid }).then((res) => {
          if (res.data.status === 0) {
            this.searchData[index].is_collected = true;
          } else {
            this.$message({
              message: "收藏失败，请重试",
              type: "error",
            });
          }
        });
      } else {
        let Logger = webTrackerEvent();
        Logger.push("page_url", window.location.href);
        Logger.push("action", "delete_collection");
        Logger.push("pmid", pmid);
        Logger.push("token", this.token);
        Logger.push("openid", this.openid);
        Logger.logger();
        collection("DELETE", { pmid: pmid }).then((res) => {
          if (res.data.status === 0) {
            this.searchData[index].is_collected = false;
          } else {
            this.$message({
              message: "取消失败，请重试",
              type: "error",
            });
          }
        });
      }
    },
    // 查看全文
    showFullText(pmid) {
      let Logger = webTrackerEvent();
      Logger.push("page_url", window.location.href);
      Logger.push("action", "fullText");
      Logger.push("pmid", pmid);
      Logger.push("token", this.token);
      Logger.push("openid", this.openid);
      Logger.logger();
      const { href } = this.$router.resolve({
        name: "fullText",
        path: "/fullText",
        query: {
          pmid: pmid
        },
      });
      window.open(href);
      // this.$router.push("fullText?pmid=" + pmid);
    },
  },
  mounted() {},
  created: function () {
    this.searchQuery = this.$route.query;
    this.handleSearch();
  },
};
</script>

<style scoped>
.relatedList {
  background: #f9f9f9;
  min-height: 700px;
  padding-bottom: 50px;
}
.relatedList .content {
  width: 1080px;
  margin: 0 auto;
}
.relatedList .content .el-card__header span {
  margin-left: 18px;
  font-size: 16px;
  color: #333;
  font-weight: bold;
  /* margin-top:4px; */
}
.relatedList .content .el-card__header button {
  padding: 10px 20px !important;
  border: 1px solid #409eff;
}
.relatedList .content .resultTtle {
  font-size: 14px;
  color: #333;
}
.relatedList .content .resultTtle .pointData {
  font-size: 12px;
  color: #eb7400;
  margin-bottom: 5px;
}
.relatedList .content .resultTtle .el-col {
  padding: 0;
}
.relatedList .content .resultTtle .num .el-col {
  padding: 0;
}
.relatedList .content .resultTtle span.sort_sp {
  line-height: 32px;
  margin-right: 10px;
  font-size: 13px;
  color: #606266;
}
.relatedList .content .resultTtle .el-select {
  width: 150px;
  line-height: 32px;
}
.relatedList .content .tags {
  margin-top: 20px;
}
.relatedList .content .tags em {
  font-size: 12px;
  color: #6098db;
}
.relatedList .content .tags span {
  margin-right: 10px;
}
.relatedList .content .tags .clearBtn {
  line-height: 32px;
}
.relatedList .content .tags .clearBtn img {
  width: 20px;
  height: 20px;
  display: block;
  margin-right: 10px;
  margin-top: 6px;
}
.relatedList .content .resultList {
  margin-top: 20px;
  font-size: 14px;
  color: #333;
  border: 1px solid #ccc;
  border-bottom: none;
}
.relatedList .content .resultList .tags {
  margin-top: 10px;
}
.relatedList .content .resultList ul li {
  border-bottom: 1px solid #ccc;
  padding: 10px;
  position: relative;
  overflow: hidden;
}
.relatedList .content .resultList .listTitle .title {
  font-size: 16px;
  color: #333;
  font-weight: bold;
}
.relatedList .content .resultList .listTitle .title .pptIcon {
  width: 20px;
  vertical-align: middle;
}
.relatedList .content .resultList .listTitle .YXYZ span {
  /* line-height: 30px; */
  margin-left: 10px;
}
.relatedList .content .resultList .listTitle .RGBZ span {
  line-height: 30px;
  margin-left: 10px;
}
.relatedList .content .resultList .listTitle .YXYZ img {
  width: 15px;
  height: 15px;
  margin-top: 2px;
}
.relatedList .content .resultList .listTitle .RGBZ img {
  width: 17px;
  height: 20px;
  margin-top: 5px;
}
.relatedList .content .resultList .listInfo {
  margin-top: 10px;
}
.relatedList .content .resultList .listInfo .el-col {
  margin-bottom: 10px;
}
.relatedList .content .resultList .listInfo .el-col span {
  color: #387ed2;
}
.relatedList .content .resultList .listInfo .initHeight {
  height: 30px;
  overflow: hidden;
}
.relatedList .content .resultList .listInfo em.down {
  /* background:#387ed2;
        border:none;
        padding:5px 10px;
        color:#fff;
        border-radius: 10px; */
  margin-top: 5px;
  font-size: 24px;
  position: relative;
  top: -24px;
  right: -60px;
  cursor: pointer;
}
.relatedList .content .resultList .listInfo .autoHeight {
  height: auto;
}
.relatedList .content .resultList .listInfo .el-col .key_infor {
  margin-top: 10px;
  line-height: 25px;
}
.relatedList .content .resultList .action {
  width: 50px;
  height: 100%;
  border-left: 1px solid #ccc;
  position: absolute;
  top: 0;
  right: 0;
  background: #f5f5f5;
  /* padding-top: 26px; */
}
.relatedList .content .resultList .action a {
  display: block;
  height: 33.3%;
}
.relatedList .content .resultList .action a.translate {
  background: url("../assets/img/icon1.png") no-repeat center center;
}
.relatedList .content .resultList .action a.fullText {
  background: url("../assets/img/icon2.png") no-repeat center center;
}
.relatedList .content .resultList .action a.collection {
  background: url("../assets/img/icon3.png") no-repeat center center;
}
.relatedList .content .resultList .action a.collectionTrue {
  background: url("../assets/img/icon3_01.png") no-repeat center center;
}
.relatedList .content .resultList .action a.share {
  background: url("../assets/img/icon4.png") no-repeat center center;
}
.relatedList .content .resultList .action a:hover {
  background-color: #387ed2;
}
.relatedList .content .resultList .action a.translate:hover {
  background-image: url("../assets/img/icon1_01.png");
}
.relatedList .content .resultList .action a.fullText:hover {
  background-image: url("../assets/img/icon2_01.png");
}
.relatedList .content .resultList .action a.collection:hover {
  background-image: url("../assets/img/icon3_02.png");
}
.relatedList .content .resultList .action a.share:hover {
  background-image: url("../assets/img/icon4_01.png");
}
.relatedList .content .el-pagination {
  margin-top: 30px;
  text-align: center;
}
.relatedList .noData {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, 0);
}
.relatedList .noData img {
  display: block;
  margin: 0 auto;
}
.relatedList .noData span {
  display: block;
  text-align: center;
  font-size: 14px;
  color: #ccc;
  margin-top: 10px;
}
/* .relatedList .content .resultList .action a img{
  width: 18px;
  height: 18px;
  display: block;
  margin: 0 auto;
}
.relatedList .content .resultList .action a img.fullText{
  width: 20px;
} */
</style>


// WEBPACK FOOTER //
// src/views/related.vue